// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ffa72f3b","453":"589b1a24","732":"842a648c"}[chunkId] + ".chunk.js";
};